// toast-service.js
let toast = null

export function setToast(instance) {
  toast = instance
}

export function showToast(options) {
  toast?.add(options)
}
